import { RouteOutlinedIcon, TravelExploreIcon, PsychologyAltOutlinedIcon, MapOutlinedIcon,
    RouteRoundedIcon, PsychologyAltIcon, MapIcon, AssistantOutlinedIcon, AssistantIcon
 } from 'src/components';

 const fontSize = 25;

export const navItems = [
    { 
        label: 'Handbook', 
        icon: <TravelExploreIcon sx={{fontSize: fontSize}}/>, 
        filledIcon: <TravelExploreIcon sx={{fontSize: fontSize}}/>, 
        path: '/handbook' 
    },
    { 
        label: 'Trips', 
        icon: <RouteOutlinedIcon sx={{fontSize: fontSize}}/>, 
        filledIcon: <RouteRoundedIcon sx={{fontSize: fontSize}}/>, 
        path: '/trips' 
    },
    { 
        label: 'Map', 
        icon: <MapOutlinedIcon sx={{fontSize: fontSize}}/>, 
        filledIcon: <MapIcon sx={{fontSize: fontSize}}/>, 
        path: '/map' 
    },
    { 
        label: 'Chat', 
        icon: <AssistantOutlinedIcon sx={{fontSize: fontSize}}/>, 
        filledIcon: <AssistantIcon sx={{fontSize: fontSize}}/>, 
        path: '/chat/ai' 
    }
];